exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "div.gs-global-muar {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 8888;\n    background-color: rgba(0,0,0,0.3);\n}\n\ndiv.gs-dropdown-win {\n    position: fixed;\n    border: 2px solid #ddd;\n    z-index: 9999;\n    right: 5px;\n    left: 10px;\n    margin: 0 5px;\n    text-align: center;\n    max-height: 80%;\n    border-radius: 3px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    background: #fff;\n}\ndiv.gs-dropdown-win > div {\n    background: #fff;\n    padding: 16px;\n    display: inline-block;\n    text-align: left;\n    width: 100%;\n}\n\ninput.glob-search-input {\n    position: relative;\n    z-index: 9999;\n    padding: 2px 4px !important;\n}\n\n\n.message-instead-result {\n    text-align: center;\n    margin: 24px;\n    font-size: 1.6em;\n    font-weight: bold;\n    padding: 24px 0;\n    opacity: 0.4;\n    background: #FFFFAA;\n    border-radius: 3px;\n    border: 1px solid #443300;\n}\n\n.message-instead-result-loading {\n    text-align: center;\n    margin: 24px;\n    font-size: 1.6em;\n    font-weight: bold;\n    padding: 24px 0;\n    opacity: 0.4;\n}\n\ntd[left-text] {\n    text-align: left;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/glob-search/style.css
// module id = 1205
// module chunks = 9